<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="chartLabelEditorModal">
    <div style="background-color: #548235; height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)"
         style="background-color: #a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Chart Labels</h5>
    </div>

    <div class="modal-body" style="margin-top: -1px; padding: 15px;">
        <!-- Add a new label of the chosen type. -->
        <div class="form-group" style="display: flex; gap: 8px; align-items: center; margin-bottom: 10px;">
            <select class="form-control" style="flex: 1;" name="newLabelType" [(ngModel)]="newLabelType">
                <option *ngFor="let t of labelTypes" [ngValue]="t.value">{{ t.label }}</option>
            </select>
            <button type="button" class="btn btn-success" (click)="add()">Add</button>
        </div>

        <!-- Existing labels. Click to edit; drag the handles on the chart to move. -->
        <div class="label-list" *ngIf="labels.length > 0; else noLabels">
            <div *ngFor="let label of labels"
                 class="label-row"
                 [class.selected]="isSelected(label)"
                 (click)="select(label)">
                <span class="label-text" [title]="typeName(label.labelType)">{{ labelPreview(label) }}</span>
                <span class="label-type">T{{ label.labelType }}</span>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="delete(label); $event.stopPropagation()">Delete</button>
            </div>
        </div>
        <ng-template #noLabels>
            <small class="text-muted">No labels yet. Choose a type and click Add.</small>
        </ng-template>

        <!-- Property editor for the selected label. -->
        <div *ngIf="selected != null" class="label-props" style="margin-top: 12px; border-top: 1px solid #ddd; padding-top: 12px;">
            <div *ngIf="!isBandType" class="form-group" style="margin-bottom: 8px;">
                <label style="display: block; font-weight: 500; margin-bottom: 2px;">Text</label>
                <textarea class="form-control" rows="2" name="labelText" [(ngModel)]="selected.text" (ngModelChange)="applyChanges()"></textarea>
            </div>

            <div class="form-group" style="margin-bottom: 8px;">
                <label style="display: block; font-weight: 500; margin-bottom: 2px;">Type</label>
                <select class="form-control" name="labelType" [(ngModel)]="selected.labelType" (ngModelChange)="applyChanges()">
                    <option *ngFor="let t of labelTypes" [ngValue]="t.value">{{ t.label }}</option>
                </select>
            </div>

            <div *ngIf="!isBandType" style="display: flex; gap: 12px; align-items: center; margin-bottom: 8px;">
                <div class="form-group" style="margin-bottom: 0;">
                    <label style="display: block; font-weight: 500; margin-bottom: 2px;">Font size</label>
                    <input type="number" class="form-control" style="width: 90px;" min="6" max="48" name="fontSize"
                           [(ngModel)]="props.fontSize" (ngModelChange)="applyChanges()" />
                </div>
                <div class="form-group" style="margin-bottom: 0;">
                    <label style="display: block; font-weight: 500; margin-bottom: 2px;">Font color</label>
                    <input type="color" class="form-control" style="width: 56px; padding: 2px;" name="fontColor"
                           [(ngModel)]="props.fontColor" (ngModelChange)="applyChanges()" />
                </div>
            </div>

            <div *ngIf="!isBandType" style="display: flex; gap: 16px; align-items: center; margin-bottom: 8px; flex-wrap: wrap;">
                <label style="margin-bottom: 0; font-weight: 400;">
                    <input type="checkbox" name="hasSticky" [(ngModel)]="props.hasStickyBackground" (ngModelChange)="applyChanges()" />
                    Sticky-note background
                </label>
                <label style="margin-bottom: 0; font-weight: 400;">
                    <input type="checkbox" name="hasShadow" [(ngModel)]="props.hasShadow" (ngModelChange)="applyChanges()" />
                    Shadow
                </label>
                <label *ngIf="hasArrow" style="margin-bottom: 0; font-weight: 400;">
                    <input type="checkbox" name="showArrow" [(ngModel)]="props.showArrow" (ngModelChange)="applyChanges()" />
                    Arrow
                </label>
            </div>

            <div *ngIf="isBandType" class="form-group" style="margin-bottom: 0;">
                <label style="display: block; font-weight: 500; margin-bottom: 2px;">Band color</label>
                <input type="color" class="form-control" style="width: 56px; padding: 2px;" name="bandColor"
                       [(ngModel)]="props.bandColor" (ngModelChange)="applyChanges()" />
            </div>
        </div>

        <div style="margin-top: 15px; display: flex; gap: 8px; align-items: center;">
            <small class="text-muted" style="flex: 1;">Drag the handles on the chart to move the label, arrow tip, or band edges.</small>
            <button type="button" class="btn btn-basic" (click)="close()">Done</button>
        </div>
    </div>
</div>
